// import { watch } from 'vue';
// на выходе данные массив обьектов содержашиеся в this.selectedUsers
{
}
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  data() {
    return {
      // selectedUsers: [],
      // selectedUsers_elem: []
    };
  },
  computed: {
    isAllSelected() {
      // Проверяем, выбраны ли все пользователи
      return this.students_id.length === this.totalUsersCount();
    },
    ...mapState({
      students: state => state.modalUsers.students,
      students_id: state => state.modalUsers.students_id
    })
  },
  methods: {
    ...mapMutations({
      SET_STUDENTS_ID: 'modalUsers/SET_STUDENTS_ID',
      PYSH_STUDENTS_ID: 'modalUsers/PYSH_STUDENTS_ID',
      SET_STUDENTS: 'modalUsers/SET_STUDENTS',
      PYSH_STUDENTS: 'modalUsers/PYSH_STUDENTS',
      FILTER_AND_REMOVE_STUDENTS: 'modalUsers/FILTER_AND_REMOVE_STUDENTS',
      FILTER_AND_REMOVE_STUDENTS_ID: 'modalUsers/FILTER_AND_REMOVE_STUDENTS_ID'
    }),
    totalUsersCount() {
      // Вспомогательный метод для получения общего количества пользователей
      return this.users.reduce((total, group) => total + group.length, 0);
    },
    isSelected(userId) {
      // Проверяем, выбран ли пользователь по его айдишнику
      return this.students_id.includes(Number(userId.user_id));
    },
    selectAll() {
      // Обработчик для выбора всех пользователей
      if (this.isAllSelected) {
        // this.selectedUsers = [];
        this.SET_STUDENTS_ID([]);
        this.SET_STUDENTS([]);
      } else {
        const members_id = this.users.reduce(
          (allUsers, group) =>
            allUsers.concat(group.map(user => Number(user.user_id))),
          []
        );
        const members = this.users.reduce(
          (allUsers, group) => allUsers.concat(group.map(user => user)),
          []
        );
        this.SET_STUDENTS_ID(members_id);
        this.SET_STUDENTS(members);
      }
    },
    isGroupSelected(group) {
      // Проверяем, выбраны ли все пользователи в группе
      return group.every(user =>
        this.students_id.includes(Number(user.user_id))
      );
    },
    selectGroup(group) {
      // Обработчик для выбора всех пользователей в группе
      if (this.isGroupSelected(group)) {
        const members_id = this.students_id.filter(
          userId => !group.some(user => Number(user.user_id) === Number(userId))
        );
        const members = this.students.filter(
          userId =>
            !group.some(user => Number(user.user_id) === Number(userId.user_id))
        );
        this.SET_STUDENTS_ID(members_id);
        this.SET_STUDENTS(members);
      } else {
        const members_id = this.students_id.concat(
          group
            .filter(user => !this.students_id.includes(Number(user.user_id)))
            .map(user => Number(user.user_id))
        );

        const members = this.students.concat(
          group
            .filter(
              user =>
                !this.students.some(member => member.user_id === user.user_id)
            )
            .map(user => ({ ...user })) // Копируем объекты для создания новых ссылок
        );

        this.SET_STUDENTS_ID(members_id);
        this.SET_STUDENTS(members);
      }
    },
    selectUser(userId) {
      // Обработчик для выбора отдельного пользователя
      if (this.isSelected(userId)) {
        this.FILTER_AND_REMOVE_STUDENTS(Number(userId.user_id));
        this.FILTER_AND_REMOVE_STUDENTS_ID(Number(userId.user_id));
      } else {
        this.PYSH_STUDENTS_ID(userId.user_id);
        this.PYSH_STUDENTS(userId);
      }
    }
  }
};
